import { render, staticRenderFns } from "./tableTd.vue?vue&type=template&id=0a9cd522"
import script from "./tableTd.vue?vue&type=script&lang=js"
export * from "./tableTd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports